import type { EmailStyleSettings } from "../../style-settings";
import { EMAIL_TOKENS } from "../../styles/tokens";
import { applyBlockStyles } from "../shared-block-styles";

import { CSSProperties } from "react";

const HEADING_SIZE_MAP: Record<1 | 2 | 3, CSSProperties> = {
  1: { fontSize: "28px", lineHeight: "36px", fontWeight: 700 },
  2: { fontSize: "22px", lineHeight: "30px", fontWeight: 600 },
  3: { fontSize: "18px", lineHeight: "26px", fontWeight: 600 },
};

/** A heading's appearance, for the canvas and for the inbox alike. */
export function getHeadingStyles(
  attrs: Record<string, unknown>,
  settings?: Partial<EmailStyleSettings>,
): CSSProperties {
  const styles: CSSProperties = {
    ...HEADING_SIZE_MAP[attrs.level as 1 | 2 | 3],
    ...(attrs.textAlign
      ? { textAlign: attrs.textAlign as CSSProperties["textAlign"] }
      : {}),
    margin: "0",
    padding: "0",
    color: settings?.headingColor || EMAIL_TOKENS.colors.text.primary,
    ...(settings?.fontFamily ? { fontFamily: settings.fontFamily } : {}),
  };
  applyBlockStyles(styles, attrs);
  return styles;
}
